import {IdPrefix} from '../idHelpers.enums';
import {idPrefixToEntityName} from '../idHelpers.config';

export default function describeIdFormat(prefix: IdPrefix | IdPrefix[]): string {
  const prefixes = Array.isArray(prefix) ? prefix : [prefix];
  const options = prefixes
    .map((p) => `${p}<object_number> (${idPrefixToEntityName[p]})`)
    .join(' or ');

  return `Expected format: ${options}`;
}
